<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules">
      <!-- <div class="query-bar">
        <el-form-item label=" " label-width="0" prop="polOb" style="margin-bottom: 0">
          <div class="query-item" :class="currentFoc === 'pol' ? 'isFocus' : ''">
            <label>起运地</label>
            <selectPlace v-model="form.polOb" :inquiryBusinessType="inquiryBusinessType" :inquiryType="inquiryType" placeholder="请选择起运地"  @focus="changeFocus('pol')" @blur="currentFoc = null" @change="setRule('polOb')"/>
            <img :src="ossPath + '/pages/home/icon_dropdown_fill.png'" alt="" class="dropdown"
                  :class="{ 'is-focus': currentFoc === 'pol' }">
          </div>
        </el-form-item>
        
        <el-form-item label=" " label-width="0" prop="podOb" style="margin-bottom: 0">
          <div class="query-item" :class="currentFoc === 'pod' ? 'isFocus' : ''">
            <label>目的地</label>
            <selectPlace ref="inquiryend" isEndPlace v-model="form.podOb" :inquiryBusinessType="inquiryBusinessType" :inquiryType="inquiryType" placeholder="请选择城市/港口"  @focus="changeFocus('pod')" @blur="currentFoc = null" @change="setRule('podOb')"/>
            <img :src="ossPath + '/pages/home/icon_dropdown_fill.png'" alt="" class="dropdown"
                  :class="{ 'is-focus': currentFoc === 'pod' }">
          </div>
        </el-form-item>
        
        <div class="query-button" @click="published">
          发布询盘
        </div>
      </div> -->
      <div class="form-card" style="position: relative">
        <!-- <h3>地址信息</h3> -->
        <div>
          <!-- <div style="display: flex">
            <p>1</p>
            <p>2</p>
          </div>
          <div style="display: flex">
            <p>1</p>
            <p>2</p>
          </div> -->
          <div class="flex-box" style=" width: 100%">
            <el-form-item label="起运地" prop="polOb" style="width: 170px; margin-right: 30px">
              <el-select v-model="form.polOb" value-key="id" placeholder="请选择港口" clearable filterable :filter-method="(query) => filterMethod(query, 'pol')" @focus="startOptions = startList" style="width: 100%">
                <el-option class="shelf_set" :label="item.type === 1 ? item.portNamec : item.cityNamec" :value="item" v-for="(item, index) in startOptions" :key="item.id">
                  <div>
                    <div class="place-item"
                      :class="{isCurrent: form.polOb && item.id === form.polOb.id}">
                    <div class="place-item__type" slot="left">
                      <img class="place-item__type-icon" :src="ossPath + (item.type === 1 ? '/pages/home/icon_port_new.png' : '/pages/home/icon_city_type.png')">
                      <div class="place-item__type-text">{{item.type === 1 ? '港口' : '城市'}}</div>
                    </div>
                    <div class="place-item__content" slot="right">
                      <div class="place-item__text-row">{{item.portNamee ? `${item.portNamee}, ` : ''}}{{item.cityNamee ? `${item.cityNamee}, ` : ''}}{{item.countryNamee || ''}}</div>
                      <div class="place-item__text-row">{{item.portNamec ? `${item.portNamec}, ` : ''}}{{item.cityNamec ? `${item.cityNamec}, ` : ''}}{{item.countryNamec || ''}}</div>
                    </div>
                  </div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的地" prop="podOb" style="width: 170px; margin-right: 30px">
              <el-select v-model="form.podOb" value-key="id" placeholder="请选择城市/港口" clearable filterable  :filter-method="(query) => filterMethod(query, 'pod')" @focus="endOptions = endList" style="width: 100%">
                <el-option class="shelf_set" :label="item.type === 1 ? item.portNamec : item.cityNamec" :value="item" v-for="(item, index) in endOptions" :key="item.id">
                  <div>
                    <div class="place-item"
                      :class="{isCurrent: form.podOb && item.id === form.podOb.id}">
                    <div class="place-item__type" slot="left">
                      <img class="place-item__type-icon" :src="ossPath + (item.type === 1 ? '/pages/home/icon_port_new.png' : '/pages/home/icon_city_type.png')">
                      <div class="place-item__type-text">{{item.type === 1 ? '港口' : '城市'}}</div>
                    </div>
                    <div class="place-item__content" slot="right">
                      <div class="place-item__text-row">{{item.portNamee ? `${item.portNamee}, ` : ''}}{{item.cityNamee ? `${item.cityNamee}, ` : ''}}{{item.countryNamee || ''}}</div>
                      <div class="place-item__text-row">{{item.portNamec ? `${item.portNamec}, ` : ''}}{{item.cityNamec ? `${item.cityNamec}, ` : ''}}{{item.countryNamec || ''}}</div>
                    </div>
                  </div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="派送详细地址" prop="podAddressDetail" style="flex-grow: 1">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 1, maxRows: 10 }" v-model="form.podAddressDetail" placeholder="请输入派送详细地址" clearable  style="width: 100%" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </div>
          <!-- <div>
          </div> -->
          <div style=" display: grid; grid-template-columns: repeat(3, 384px); grid-gap: 0 20px;">
            <el-form-item :label="`箱型/箱量${i + 1}`" v-for="(item, i) in form.boxTypeList" :key="i" :rules="[{ required: true, message: '请选择箱型'}]" :prop="`boxTypeList[${i}].boxTypeId`">
              <div style="width: 100%">
                <el-select style="width: 120px" v-model="form.boxTypeList[i].boxTypeId" placeholder="请选择箱型" clearable>
                  <el-option v-for="item in boxTypeOptions" :key="item.id" :label="item.code" :value="item.id" :disabled="setDisabled(item.id)"></el-option>
                </el-select>
                <el-input-number class="short-input" style="margin: 0 15px 0 10px" v-model="form.boxTypeList[i].boxNum" :min="1" :step="1" :controls="true" controls-position="both" @change="(val) => changeNum(val, i)">
                </el-input-number>
                <span style="vertical-align: -4px; margin-right: 10px; cursor: pointer" @click="form.boxTypeList.push({boxNum: 1})">
                  <img :src="ossPath + '/pages/inquiryHall/icon_plus.png'" alt="">
                </span>
                <span style="vertical-align: -4px; cursor: pointer" v-if="i !== 0 || form.boxTypeList.length > 1" @click="form.boxTypeList.splice(i, 1)">
                  <img :src="ossPath + '/pages/inquiryHall/icon_del.png'" alt="">
                </span>
              </div>
            </el-form-item>
          </div>
          <div class="flex-box">
            <el-form-item label="商品名称" prop="goodsName" style="width: 370px; margin-right: 30px">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 1, maxRows: 10 }" style="width: 100%" v-model="form.goodsName" placeholder="请输入商品名称或HS Code，支持用/，隔开" clearable maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="预计出货日期" prop="sendGoodsTime" style="width: 240px; margin-right: 30px">
              <el-date-picker style="width: 100%;" v-model="form.sendGoodsTime" value-format="yyyy-MM-dd" type="date" size="normal" placeholder="请选择" prefix-icon="el-icon-date">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="需求说明" prop="needDescription" style="margin-bottom: 0; flex-grow: 1">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 1, maxRows: 10 }" style="width: 100%" v-model="form.needDescription" placeholder="请输入需求说明" clearable maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </div>
          <div style="position: relative; height: 0">
            <!-- 占位用 -->
            <el-form-item label="占位" style="opacity: 0; width: 0">
              <el-input></el-input>
            </el-form-item>
          </div>
          <!-- <div class="">
          </div>
          <div>
          </div> -->
          <div align="right">
            <div class="primary-button" @click="publishCommit">发布询盘</div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {isObject} from "my-tools-kit"
import {mapState, mapGetters} from 'vuex'
import selectPlace from './selectPlace'
import selectGoodsType from './selectGoodsType'
import {sendCustomerOperationRecord} from "@/assets/js/utils"
export default {
  components: {
    selectPlace,
    selectGoodsType
  },
  props: {
    initForm: {
      type: Object,
      default: () => {}
    },
    inquiryBusinessType: { // 询盘业务类型  1 海运整柜 、2 FBA、3 海运拼箱、4 空运、5 陆运
      type: [String,Number],
      default: 1,
    },
    inquiryType: { // 1、港到港 2、整柜到门 3、门到港 4、门到门
      type: [String,Number],
      default: 2,
    }
  },
  data() {
    return {
      form: {
        // findSupplierNum: 5,
        boxTypeList: [{
          boxNum: 1
        }]
      },
      rules: {
        polOb: [{ required: true, message: '请选择起运地', trigger: 'change' }],
        podOb: [{ required: true, message: '请选择目的地', trigger: 'change' }],
        podAddressDetail: [{ required: true, message: '请输入派送详细地址' }, { min: 10, message: '请至少输入10个字符' }],
        goodsName: [{ required: true, message: '请输入商品名称' }],
        sendGoodsTime: [{ required: true, message: '请选择预计出货日期' }],
        // needDescription: [{ required: true, message: '请输入需求说明' }]
      },
      boxTypeOptions: [],
      successVisible: false,
      currentFoc: null,
      startList: [],
      endList: [],
      startOptions: [],
      endOptions: [],
    }
  },
  computed: {
    ...mapState(['Authorization']),
    ...mapGetters(["token"]),
  },
  watch: {
    token: {
      immediate: true,
      handler(val) {
       if (val) this.getBoxTypeList()
      }
    }
  },
  mounted() {
    this.getDefaultList()
  },
  methods: {
    filterMethod(query, type) {
        let filterFunction = (text="",item)=>{
        // console.log("============",item[this.itemLabelKey])
        let itemLabel = String(item.cityNamec||"");
        let itemLabelE = String(item.cityNamee||"")
        let itemLabel1 = String(item.portNamec||"");
        let itemLabelE1 = String(item.portNamee||"")
        let itemLabel2 = String(item.countryNamec||"");
        let itemLabelE2 = String(item.countryNamee||"")
        let itemLanbelCode = String(item.portCode || '')
        let reg = RegExp(text,"ig");
        return reg.test(itemLabel) || reg.test(itemLabelE) || reg.test(itemLabel1) || reg.test(itemLabelE1) || reg.test(itemLabel2) || reg.test(itemLabelE2) || reg.test(itemLanbelCode);
      };
      if (type === 'pol') {
        if (query) {
          this.startOptions = this.startList.filter(item=>{
            return filterFunction(query,item);
          })
        } else this.startOptions = this.startList
      } else {
        if (query) {
          this.endOptions = this.endList.filter(item=>{
            return filterFunction(query,item);
          })
        } else this.endOptions = this.endList
      }
    },

     /**
     * 获取海外港列表
     */
     getList(isEndPlace){
      const data = {
        type: isEndPlace ? 2 : 1,
        inquiryBusinessType: this.inquiryBusinessType
      }
      if (data.inquiryBusinessType == '1') data.inquiryType = this.inquiryType
      // if (isEndPlace) data.countryId = this.form.polOb.countryId
      return this.axios.post('/api/fullContainer/getHomeCityPortList', data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return {data:res.datas||[]};
        })
    },
    getDefaultList(){
      this.getList()
        .then(res=>{
          this.startList = res.data;
          this.startOptions = this.startList
        })
        .catch(res=>{
          this.startList = [];
          this.startOptions = this.startList
        })
        this.getList(true)
        .then(res=>{
          this.endList = res.data;
          this.endOptions = this.endList
        })
        .catch(res=>{
          this.endList = [];
          this.endOptions = this.endList
        })
    },
    setRule(val) {
      this.$refs.form.validateField(val)
    },
    setDisabled(id) {
      return this.form.boxTypeList.find(v => v.boxTypeId === id ) ? true : false
    },
    getBoxTypeList () {
      // busFCL/findAllCntype
      this.axios.get('/busFCL/findAllCntype')
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return
          this.boxTypeOptions = res.datas
        })
    },
    connectBoxStr(list) {
      if (!list) return ''
      let text = ''
      list.forEach((el, i) => {
        const boxName = this.boxTypeOptions.find(v => v.id === el.boxTypeId).code
        if (i === 0) {
          text += `${boxName}*${el.boxNum}`
        } else {
          text += `, ${boxName}*${el.boxNum}`
        }
      })
      return text
    },
    changeNum(val, i) {
      this.$nextTick(() => {
        if (!val) this.$set(this.form.boxTypeList[i], 'boxNum', 1)
      })
    },
    publishCommit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const data = {
          inquiryBusinessType: this.inquiryBusinessType,
          inquiryType: this.inquiryType,
          customerId: this.Authorization.customerid,
          userId: this.Authorization.userId,
          ...this.form
        }
        data.boxTypeList = this.form.boxTypeList.map((v, i) => {
          const {
            boxNum,
            boxTypeId
          } = v
          return {
            boxNum,
            boxTypeId,
            sort: i
          }
        })
        // data.goodsTypeList = this.form.goodsTypeList.map((v, i) => {
        //   const {
        //     goodsTypeName
        //   } = v
        //   return {
        //     goodsTypeName,
        //     goodsTypeId: v.id,
        //     sort: i
        //   }
        // })
        data.polId = data.polOb.id
        data.polType = data.polOb.type
        data.podId = data.podOb.id
        data.podType = data.podOb.type
        delete data.polOb
        delete data.podOb
        console.log(data)
        
        sendCustomerOperationRecord('提交发布询盘', `类型：整柜到门， 起运地：${this.form.polOb.portCode ? this.form.polOb.portNamec : this.form.polOb.cityNamec}，目的地：${this.form.podOb.portCode ? this.form.podOb.portNamec : this.form.podOb.cityNamec}，柜型：${this.connectBoxStr(this.form.boxTypeList)}`)
        this.axios.post('/fullContainer/addFullContainerInquiryInfoNew', data).then(res => {
          if (res.data.code === 200) {
            // this.$message.success('成功')
            // this.successVisible = true
            this.$router.replace({
              name: 'publishedSuccess',
              query: {
                id: res.data.data.inquiryId
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    changeFocus(val) {
      setTimeout(() => {
        this.currentFoc = val
      }, 20)
    },
    published() {
      // const data = {
      //   // goodsTypesList: this.form.goodsType ? this.form.goodsType.map(v => v.id).filter(v => v !== 'ALL') : [],
      //   // podId: 0,
      //   // polId: 0
      // }
      // if (this.form.pol.id && this.form.pol.id !== 'ALL') data.polId = this.form.pol.id
      // if (this.form.pod.id && this.form.pod.id !== 'ALL') data.podId = this.form.pod.id
      // sendCustomerOperationRecord('整柜询盘-查询', `起运地：${this.form.pol.portCode ? this.form.pol.portNamec : this.form.pol.cityNamec}，目的地：${this.form.pod.portCode ? this.form.pod.portNamec : this.form.pod.cityNamec}`)
      // this.$emit('published', this.form)
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      if (this.Authorization.authenticationInfoDTO.type != '1' || this.Authorization.authenticationInfoDTO.state != '3') return this.blockvisible = true
      this.publishCommit()
    },
    // setEndData(val) {
    //   if (!val) this.$set(this.form, 'pol', {})
    //   this.$set(this.form, 'pod', {})
    //   console.log(this.$refs.inquiryend)
    //   this.$nextTick(() => {
    //     this.$refs.inquiryend.getDefaultList()
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
  .query-bar {
    display: flex;
    background: #ffffff;
    .query-item {
      box-sizing: border-box;
      position: relative;
      margin-right: 10px;
      padding: 14px 20px;
      width: 480px;
      max-width: 480px;
      height: 90px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #E3E3E3;
      .select-place {
        /deep/ .search-text {
          .el-input__inner::placeholder {
            font-size: 18px;
            font-weight: bold;
            color: #999999;
          }
        }
      }
      &.isFocus {
        border: 1px solid #141414;
      }
      label {
        margin-bottom: 8px;
        display: block;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      /deep/ .select-place {
        line-height: 28px;
        font-size: 20px;
        font-weight: bold;
        color: #141414;
        background: transparent;
        .text-row {
          padding: inherit
        }
      }
      .right-icon {
        position: absolute;
        bottom: 22px;
        right: 20px;
        font-size: 16px;
        color: #141414;
      }
    }
    .query-button {
      width: 188px;
      height: 90px;
      line-height: 90px;
      background: #FF4D01;
      color: #FFFFFF;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      img {
        margin-bottom: 3px;
        width: 21px;
        height: 21px;
        vertical-align: middle
      }
    }
  }
  
  .dropdown {
    position: absolute;
    right: 21px;
    bottom: 24px;
    transform: rotate(0);
    transition: all .3s ease;
    &.is-focus {
      transform: rotate(180deg);
    }
  }
  .form-card {
  // margin-bottom: 20px;
  // padding-top: 20px;
  background: #FFFFFF;
  border-radius: 12px;
  color: #141414;
  font-size: 16px;
  font-weight: bold;
  &>h3 {
    &::before {
      content: '';
      margin-right: 6px;
      display: inline-block;
      width: 4px;
      height: 22px;
      background: #FF4D01;
      vertical-align: text-bottom;
      border-radius: 1px;
    }
  }
  .el-form-item {
    margin-bottom: 12px;
    /deep/ .el-form-item__content {
      width: 100%!important;
      margin-left: 0 !important;
    }
    /deep/ .el-textarea__inner {
      min-height: 40px!important;
      line-height: 28px !important;
      &::placeholder {
        color: #999999;
      }
    }
    /deep/ .el-textarea {
      .el-input__count {
        line-height: 30px !important;
      }
    }
    /deep/ .el-input__inner {
      &::placeholder {
        color: #999999;
      }
    }
  }
  h3,
  .contain,
  .el-form-item /deep/ .el-form-item__label {
    width: 100%!important;
    color: #999999;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .el-form-item /deep/ .el-input__inner, /deep/ .el-textarea__inner {
    color: #141414;
    font-size: 14px;
    font-weight: bold;
    border-color: #EEEEEE;
    &:focus {
      border-color: #FF4D01
    }
  }
  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #F56C6C;
  }
  /deep/ .el-input-number__decrease {
    left: 2px;
    background: transparent;
  }
  /deep/ .el-input-number__increase {
    background: transparent;
  }
  /deep/ .el-form-item__error {
    font-weight: normal;
  }
  h3 {
    margin-bottom: 25px;
    font-size: 20px;
  }
  .short-input {
    width: 152px;
  }
  .el-date-editor {
    /deep/ .el-input__inner {
      padding-left: 15px;
    }
    /deep/ .el-input__prefix {
        position: absolute;
        left: 205px; // left根据实际情况定值
        top: 0;
        color:#141414;
        font-size: 20px;
        .el-input__icon {
          font-weight: bold;
        }
        
     }
     /deep/ .el-input__suffix {
      right: 30px;
     }
    //  input {
    //    padding-left: 15px;
    //  }
  }
}
.flex-box {
  display: flex;
  // div {
  //   display: inline-block;
  // }
}

.connect-left {
  /deep/ .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
  }
}
.connect-right {
  /deep/ .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
  }
}
.shelf_set.el-select-dropdown__item {
  height: auto;
  min-height: 34px;
  padding: 0 !important;
  &:hover {
    background: transparent;
  }
}
.primary-button {
  display: inline-block;
  margin-top: 10px;
  width: 270px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #FF4D01;
  font-size: 22px;
  font-weight: bold;
  color: #FFFFFF;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    opacity: .8;
  }
}

.place-item{
  width: 100%;
  height: 50px;
  // margin: 7px 0;
  padding-right: 10px;
  //padding: 20px 20px 18px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover{
    background-color: rgba(255, 77, 1, .1);
    color: #FF4D01;
  }
  &.isCurrent {
    background-color: rgba(255, 77, 1, .1);
    color: #FF4D01;
    .place-item__text-row {
      color: #FF4D01;
    }
  }
  &__type{
    width: 64px;
    position: relative;
    z-index: 1;
    // &:before{
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   bottom: 0;
    //   right: 0;
    //   width: 1px;
    //   background-color: #D7D7D7;
    // }
    &-icon{
      //width: 19px;
      display: block;
      min-width: 1px;
      width: auto;
      height: 20px;
      margin: 0 auto;
    }
    &-text{
      text-align: center;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
  &__content{
    margin-left: 5px;
  }
  &__text-row{
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
  &:hover &__text-row{
    color: inherit;
  }
}

.el-input-number /deep/ .el-input-number__decrease {
  color: #141414;
  .el-icon-plus {
    font-weight: bold!important;;
  }
}
.el-input-number /deep/ .el-input-number__increase {
  color: #141414;
  /deep/ .el-icon-minus {
    font-weight: bold!important;;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/inquiryQueryBar/home-query.vue